import {Grid, Typography} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC} from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    recommendedText: {
      margin: '0 0 0 35px',
    },
  }),
);

interface PropsFromParent {
  recommondetionString: string;
}
export const RecommondetionTextRow: FC<PropsFromParent> = React.memo((props) => {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.recommendedText} variant="body1">
          {props.recommondetionString}
        </Typography>
      </Grid>
    </>
  );
});
